var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meaning-list"},_vm._l((_vm.meanings),function(meaning,index){return _c('a',{key:index,staticClass:"plain-link",on:{"click":function($event){return _vm.$emit('navigateTo', meaning)}}},[_vm._v(_vm._s(meaning))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }